<template>
  <div>
    <!-- <div v-if="searchable && searchPlace === 'top'"
         class="search-con search-con-top">
      <Select v-model="searchKey"
              class="search-col">
        <Option v-for="item in tableColumns"
                v-if="item.hasOwnProperty('key') && item.key != 'note' && item.key != 'time'"
                :value="item.key"
                :key="`search-col-${item.key}`">{{ item.title }}</Option>
      </Select>
      <Input @on-change="handleClear"
             clearable
             placeholder="输入关键字搜索"
             class="search-input"
             v-model="searchValue" />
      <Button @click="handleSearch"
              class="search-btn"
              type="primary">
        <Icon type="search" />&nbsp;&nbsp;搜索</Button>
    </div> -->
    <Table
      :loading="loading"
      :border="showBorder"
      :stripe="showStripe"
      :show-header="showHeader"
      :height="fixedHeader ? 500 : ''"
      :size="tableSize"
      :data="tableData"
      :columns="tableColumns"
      :editable="editable"
      :searchable="searchable"
      :searchPlace="searchPlace"
      :highlight-row="highlightRow"
      tooltip-theme="dark"
      ref="selection"
      :show-footer="showFooter"
    >
      <template slot-scope="{ row, index }" slot="note">
        <Input type="text" v-model="editNote" v-if="editIndex === index" />
        <span v-else>{{ row.note }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="warning"
          size="small"
          v-if="editIndex === index"
          @click="notesave(row)"
          >保存</Button
        >
        <!-- <Button v-if="editIndex === index"
                @click="editIndex = -1">取消</Button> -->

        <Button
          v-else
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="noteedit(row, index)"
          >备注</Button
        >
        <Button
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="goto(row)"
          >详情</Button
        >
        <Button
          type="error"
          size="small"
          style="margin-right: 5px"
          @click="unSelect(row)"
          >取消</Button
        >
        <Button
          type="primary"
          class="black-button"
          size="small"
          style="margin-right: 5px"
          @click="goto(row)"
          >拉黑</Button
        >
      </template>
    </Table>

    <div style="margin: 10px;overflow: hidden">
      <div style="float:left"></div>
      <!-- <Button @click="handleSelectAll(true)">批量领取</Button>
        <Button @click="handleSelectAll(false)">取消批量领取</Button> -->
    </div>
    <div style="float: right;">
      <Page
        :total="infoTotal"
        :page-size="rowNums"
        :current="curpage"
        show-total
        show-elevator
        show-sizer
        @on-page-size-change="changePageSize"
        @on-change="changePage"
      ></Page>
    </div>
  </div>
</template>
<script>
import '_c/caijisystem/tables/search.less';
export default {
  data () {
    return {
      timer: null,
      rowColor: false,
      tableData: [],
      sourceFilter: [
        { label: '58同城', value: '1' },
        { label: '赶集网', value: '2' }
      ],
      timeFilter: [
        {
          label: '今天',
          value: '今天'
        },
        {
          label: '1小时前',
          value: '1小时'
        },
        {
          label: '8小时前',
          value: '8小时'
        },
        {
          label: '12小时前',
          value: '12小时'
        },
        {
          label: '1天前',
          value: '1天'
        },

        {
          label: '3天前',
          value: '3天'
        }
      ],
      showBorder: true, // 显示表格列边框
      showStripe: true, // 显示斑马线样式
      showHeader: true, // 显示表头
      showIndex: true, // 显示索引序号
      showExpand: false, // 显示简要介绍
      showCheckbox: false, // 显示复选框
      fixedHeader: false, // 固定表头
      highlightRow: true, // 高亮选择的行

      editIndex: -1,
      editNote: '',
      editable: true, // 全局设置是否可编辑
      searchable: true, // 是否可搜索
      searchPlace: 'top', // 搜索控件所在位置，'top' / 'bottom'
      searchKey: '',
      searchValue: '',
      loading: false,
      // tooltip: true,
      tableSize: 'small',
      showFooter: true,
      fromPage: 1,
      rowNums: 10000,
      infoTotal: 0
    };
  },
  computed: {
    curTimeStamp () {
      return Date.parse(new Date()) / 1000;
    },
    curpage () {
      return this.fromPage;
    },
    tableColumns () {
      let columns = [];
      // eslint-disable-next-line no-unused-vars
      let gettime = this.gettime;
      if (this.showCheckbox) {
        columns.push({
          type: 'selection',
          width: 60,
          align: 'center'
        });
      }
      if (this.showIndex) {
        columns.push({
          type: 'index',
          width: 50,
          align: 'center'
        });
      }
      if (this.showExpand) {
        columns.push({
          type: 'expand',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            });
          }
        });
      }
      // columns.push({
      //   title: '来源',
      //   key: 'source_id',
      //   width: '60',
      //   align: 'center',
      //   filterMultiple: false,
      //   filters: this.sourceFilter,
      //   filterMethod (value, row) {
      //     return row.source_id === value;
      //   }
      // });
      columns.push({
        title: '发布时间',
        key: 'time',
        sortable: false,
        width: 107,
        align: 'center',
        // eslint-disable-next-line no-dupe-keys
        sortable: true
        // filters: this.timeFilter,
        // filterMethod (value, row) {
        //   return gettime(value, row);
        //   // return row.time.indexOf(value) > -1;
        // }
      });
      columns.push({
        title: '标题',
        key: 'title',
        width: 'auto',
        minWidth: 180
      });
      // columns.push({
      //   title: 'LINK',
      //   key: 'link',
      //   width: '200'
      // });

      columns.push({
        title: '区域',
        key: 'area',
        sortable: false,
        width: 'auto',
        minWidth: 180,
        align: 'center',
        filters: this.Areafilters,
        filterMultiple: false,
        filterMethod (value, row) {
          console.log('row', row.area);
          if (row.area.indexOf(value) > -1) {
            return row.area;
          }
        }
      });
      columns.push({
        title: '手机号',
        key: 'phone',
        width: 112,
        align: 'center'
        // filterMultiple: false,lianxi
        // filters: this.sourceFilter,
        // filterMethod (value, row) {
        //   return row.phone === value;
        // }
      });
      columns.push({
        title: '编辑',
        key: 'user_name',
        width: 'auto',
        minWidth: 120,
        align: 'center',
        slot: 'note'
      });

      // columns.push({
      //   title: '备注时间',
      //   key: 'noteTime',
      //   width: 107,
      //   align: 'center',
      //   sortable: true
      // });

      columns.push({
        title: '截止时间',
        key: 'expTime',
        width: 107,
        align: 'center',
        sortable: false
      });

      columns.push({
        title: '操作',
        slot: 'action',
        width: 230,
        align: 'center'
      });

      return columns;
    }
  },

  created () {
    console.log('表格头部', this.tableColumns);
    // 在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem('store')) {
    //   this.$store.replaceState(
    //     Object.assign(
    //       {},
    //       this.$store.state,
    //       JSON.parse(sessionStorage.getItem('store'))
    //     )
    //   );
    // }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener('beforeunload', () => {
    //   sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    // });
  },
  mounted () {
    this.getInfos(this.fromPage, this.rowNums);
    this.getInfoTotal();
  },
  watch: {
    curTimeStamp (newval, oldval) {
      console.log('newval', newval);
      console.log('oldval', oldval);
    }
  },
  methods: {
    expsetting (arr) {
      arr.forEach((row, index) => {
        // let untimes = row.expTimeStamp - this.curTimeStamp;
        // if (untimes > 0) {
        //   this.countDown2(untimes, index);
        // }

        console.log('this.tableData', this.tableData);
        if (row.expTimeStamp - this.curTimeStamp < 600) {
          console.log('过期了哦!');
          this.rowColor = true;
          // this.unSelect(row);
        }
      });
    },
    note () {
      this.showExpand = true;
    },
    getInfoTotal () {
      this.$axios
        .request({
          url: 'caiji/?s=info2.getlistcount',
          method: 'GET'
        })
        .then(json => {
          console.log(json);
          this.infoTotal = Number(json.data.data);
        });
    },
    goto (data) {
      window.open(data.link);
    },
    getInfos (fromPage, rowNums) {
      this.loading = true;
      let curUserId = this.$store.state.user.userId;
      console.log('curUserId', curUserId);
      this.$axios
        .request({
          url: 'caiji/?s=info2.getlist&selected=1&userId=' + curUserId,
          method: 'GET'
        })
        .then(json => {
          console.log(json);
          this.tableData = json.data.data;
          this.expsetting(this.tableData);
          this.loading = false;
        });
    },
    handleSelectAll (status) {
      this.$refs.selection.selectAll(status);
    },
    unSelect (data) {
      console.log('data', data);
      this.$Modal.confirm({
        title: '提示:',
        content: '<p>您确定要取消保护吗?</p>',
        onOk: () => {
          this.$axios
            .request({
              url: 'caiji/?s=info2.edit&id=' + data.id,
              data: { selected: null },
              method: 'POST'
            })
            .then(json => {
              console.log(json);
              this.$Modal.remove();
              this.$Message.info(' 取消成功!信息已经回到待领取中页中!');
              this.getInfos(this.fromPage, this.rowNums);
            });
        }
      });
    },
    addNote (data) {
      console.log('data', data);
      this.$axios
        .request({
          url: 'caiji/?s=info2.edit&id=' + data.id,
          data: { note: data.note, selected: 1, noteTime: new Date() },
          method: 'POST'
        })
        .then(json => {
          console.log('备注存入数据库', json);
          this.getInfos(this.fromPage, this.rowNums);
        });
    },
    selectmeBatch (data) {
      console.log('data', data);
    },
    changePage (pageNumber) {
      // this.fromPage = pageNumber;
      this.getInfos(pageNumber, this.rowNums);
      // console.log('下页数据', pageNumber);
    },
    changePageSize (pageSize) {
      // console.log('pageSize', pageSize)
      this.rowNums = pageSize;
      // console.log('frompage', this.fromPage)
      this.getInfos(this.fromPage, this.rowNums);
    },
    noteedit (row, index) {
      this.editNote = row.note;
      this.editIndex = index;
    },
    notesave (row) {
      if (!this.editNote) {
        this.editIndex = -1;
      } else {
        row.note = this.editNote;

        this.editIndex = -1;

        console.log(row);
        let userId = this.$store.state.user.userId;
        let postData = {
          phone: row.phone,
          note: row.note,
          userId: userId
        };
        this.$axios
          .request({
            url: 'caiji/?s=note2.save',
            data: postData,
            method: 'POST'
          })
          .then(json => {
            console.log('handleSubmit', json);
            let jsonData = json.data;
            if (jsonData.ret === 200) {
              this.$Message.success('备注保存成功,请进入已备注的信息中查看');
            } else {
              this.$Message.error(jsonData.msg);
            }
          });
      }
    },
    getBirthday (birthday) {
      // const date = new Date(parseInt(birthday));
      // const year = date.getFullYear();
      // const month = date.getMonth() + 1;
      // const day = date.getDate();
      // return `${year}-${month}-${day}`;
    },
    // 单纯分钟和秒倒计时
    countDown2 (time, index) {
      var timer = null;
      var t = time;
      var m = 0;
      var s = 0;
      var str = '';
      m = Math.floor((t / 60) % 60);
      m < 10 && (m = '0' + m);
      s = Math.floor(t % 60);
      let _this = this;
      function countDown () {
        s--;
        s < 10 && (s = '0' + s);
        if (s.length >= 3) {
          s = 59;
          m = '0' + (Number(m) - 1);
        }
        if (m.length >= 3) {
          m = '00';
          s = '00';
          clearInterval(timer);
        }
        console.log(m + '分钟' + s + '秒');
        str = m + '分钟' + s + '秒';
        _this.$set(_this.tableData[index], 'countdown', str);
      }
      timer = setInterval(countDown, 1000);
    },
    countDown (times, index) {
      this.timer = null;
      let _this = this;

      timer = setInterval(function () {
        if (timer) {
          clearInterval(timer);
        }
        let day = 0;
        let hour = 0;
        let minute = 0;
        let second = 0; // 时间默认值
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24));
          hour = Math.floor(times / (60 * 60)) - day * 24;
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60;
          second =
            Math.floor(times) -
            day * 24 * 60 * 60 -
            hour * 60 * 60 -
            minute * 60;
        }
        if (day <= 9) day = '0' + day;
        if (hour <= 9) hour = '0' + hour;
        if (minute <= 9) minute = '0' + minute;
        if (second <= 9) second = '0' + second;
        //
        console.log(
          day + '天:' + hour + '小时：' + minute + '分钟：' + second + '秒'
        );
        let str =
          day + '天:' + hour + '小时：' + minute + '分钟：' + second + '秒';
        _this.$set(_this.tableData[index], 'countdown', str);

        times--;
      }, 1000);
      if (times <= 0) {
        clearInterval(timer);
      }
    }
  }
};
</script>
<style lang="css" scope>
.black-button {
  background: #141414;
}
</style>
